import { render, staticRenderFns } from "./FacilityDashboard.vue?vue&type=template&id=9a582f8e&scoped=true"
import script from "./FacilityDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FacilityDashboard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FacilityDashboard.vue?vue&type=style&index=0&id=9a582f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a582f8e",
  null
  
)

export default component.exports